import { useEffect } from "react";
import { syncBrowserNotifications } from "../firebase/browserNotifications";
import { listenForLiveNotificationFeed } from "../firebase/liveNotificationFeed";

export const useFirebaseNotifications = ({ enabled, userId }) => {
  useEffect(() => {
    if (!enabled || !userId) return undefined;
    let active = true;
    const stopLiveFeed = listenForLiveNotificationFeed(userId, () => {
      if (active) window.dispatchEvent(new Event("kewordal:notification-refresh"));
    });

    syncBrowserNotifications(userId).catch((error) => {
      console.warn("Browser notification registration failed:", error);
    });

    return () => {
      active = false;
      stopLiveFeed();
    };
  }, [enabled, userId]);
};
